import React from "react";
import { Pencil, Pin, Trash2 } from "lucide-react";
import { Deck } from "@/common/decks";

interface OptionsDropdownProps {
  isOpen: boolean;
  deck: Deck;
  position?: "left" | "right";
  onTogglePin: (deck: Deck) => void;
  onDelete: (deckId: string) => void;
  onEdit?: (deckId: string | undefined) => void;
  onClose: () => void;
}

const OptionsDropdown = React.memo<OptionsDropdownProps>(
  ({
    isOpen,
    deck,
    position = "right",
    onTogglePin,
    onDelete,
    onEdit,
    onClose,
  }) => {
    const positionClasses = position === "left" ? "right-full" : "left-full";

    return (
      <div
        className={`${
          isOpen ? "block" : "hidden"
        } absolute top-0 ${positionClasses} w-48 bg-white rounded-md shadow-md overflow-hidden z-10`}
        onClick={(e) => e.stopPropagation()}
      >
        <ul>
          <li
            className="flex items-center gap-x-2 pt-2 pb-3 px-4 border-b border-deck-500 bg-white transition text-deck-primary cursor-pointer text-sm hover:bg-deck-500"
            onClick={() => {
              onTogglePin(deck);
              onClose();
            }}
          >
            <Pin
              className={`text-deck-primary cursor-pointer ${
                deck.pinned ? "fill-deck-primary" : ""
              }`}
              size={20}
            />
            <span>{deck.pinned ? "Unpin" : "Pin"}</span>
          </li>
          <li
            className="flex items-center gap-x-2 pt-2 pb-3 px-4 border-b border-deck-500 bg-white transition text-deck-primary cursor-pointer text-sm hover:bg-deck-500"
            onClick={() => {
              onEdit?.(deck.id);
              onClose();
            }}
          >
            <Pencil className="text-deck-primary" size={20} />
            <span>Edit</span>
          </li>
          {/* <li className="flex items-center gap-x-2 pt-2 pb-3 px-4 border-b border-deck-500 text-deck-primary cursor-pointer text-sm hover:bg-deck-500">
          <Download className="text-deck-primary" size={20} />
          <span>Export</span>
        </li> */}
          <li
            className="flex items-center gap-x-2 pt-2 pb-3 px-4 border-b border-deck-500 text-deck-danger cursor-pointer text-sm hover:bg-deck-500"
            onClick={() => deck.id && onDelete(deck.id)}
          >
            <Trash2 className="text-deck-danger" size={20} />
            <span>Delete</span>
          </li>
        </ul>
      </div>
    );
  },
);

OptionsDropdown.displayName = "OptionsDropdown";

export default OptionsDropdown;
